export const ROOT_PATH = '/feed' as const;
/** The in-app detail for a transaction-backed item — a resource booking OR an event. */
export const TRANSACTION_PATH = '/feed/transactions/:transactionUuid' as const;
/** Relative form used to navigate from the feed, so the query string (segment + filter) stays in history. */
export const TRANSACTION_SEGMENT = 'transactions' as const;
export const ERROR_PATH = '/error' as const;
export const SDK_DEMO_PATH = '/sdk-demo' as const;

/** Patterns the impression observer resolves a pathname back to. `matchPath` is exact, so order is irrelevant. */
export const ALL_PATHS = [TRANSACTION_PATH, ROOT_PATH, ERROR_PATH, SDK_DEMO_PATH] as const;
